// Fixtures réelles d'antonin_girardeau extraites de dev Supabase
// (session Studio + analyse vidéo). Utilisées par LandingPage pour
// montrer les vrais composants Merlin avec de la vraie data.

import reelThumb from '../assets/landing_reel_DVylFdyCNcy.jpg'
import formatThumb from '../assets/landing_format_DQKD69Xje6l.jpg'

export const ANTONIN_FORMAT = {
  "locked": false,
  "source": {
    "lien": "https://www.instagram.com/reel/DQKD69Xje6l/",
    "vues": 23969546,
    "niche": "Création de contenus, Marketing",
    "createur": null,
    "engagement": 0.26,
    "format_nom": "Témoignage face caméra avec démonstration en incrustation et textes synchronisés",
    "poster_url": formatThumb,
    "arc_narratif": "Problème → Solution",
    "hook_original": "lately I've been thinking about how easy it is to lose touch with new followers",
    "duree_secondes": 33,
    "mecanisme_viral": "Valeur",
    "script_original": "Récemment, je me suis demandé à quel point il est facile de perdre le contact avec ses nouveaux abonnés.\nQuelqu'un clique sur 'suivre', il est enthousiaste à l'idée de tomber sur votre page,\nquelques jours plus tard... il oublie pourquoi il vous avait suivi.\nC'est exactement pour ça que je viens de commencer à utiliser la nouvelle fonctionnalité Follow-to-DM de ManyChat, qu'ils ont lancée lors de leur Virtual IG Summit.\nCela signifie que dès que quelqu'un me suit, il reçoit automatiquement un petit MESSAGE de bienvenue.\nJuste une intro sympa et ce à quoi il peut s'attendre de ma page.\nC'est une façon tellement simple de faire en sorte que vos nouveaux abonnés SE SENTENT VUS\net de commencer à tisser de vraies connexions AVEC EUX.\nSi vous voulez essayer par vous-même, commentez simplement 'FOLLOW' et je vous enverrai ManyChat Pro gratuitement.",
    "categorie_format": [
      "Éducatif",
      "Témoignage",
      "Démonstration"
    ],
    "emotion_primaire": "Curiosité"
  },
  "format_id": "4aa64d8f-41e8-4f49-8d5c-5ec6f916a02a",
  "structure": [
    {
      "beat": 1,
      "texte": "Une question rhétorique sur une mauvaise pratique invisible pour créer une reconnaissance immédiate chez l'audience.",
      "fonction": "Hook"
    },
    {
      "beat": 2,
      "texte": "On raconte le scénario précis de la douleur, de l'espoir initial jusqu'au moment où tout s'effondre, pour que le spectateur se dise 'c'est exactement moi'.",
      "fonction": "Agitation"
    },
    {
      "beat": 3,
      "texte": "Le 'c'est pour ça que' introduit la solution comme une réponse logique et inévitable à la douleur qu'on vient de décrire.",
      "fonction": "Pivot"
    },
    {
      "beat": 4,
      "texte": "On explique le mécanisme concret de la solution en une phrase, avec un déclencheur et un résultat automatique pour rendre ça tangible.",
      "fonction": "Solution"
    },
    {
      "beat": 5,
      "texte": "On traduit la solution en résultat émotionnel et concret pour l'audience, ce qu'elle ressent ou obtient vraiment.",
      "fonction": "Preuve / Bénéfice"
    },
    {
      "beat": 6,
      "texte": "Un appel à l'action bas seuil avec mot-clé à commenter pour recevoir une ressource gratuite, ce qui boost l'engagement et l'algorithme en même temps.",
      "fonction": "CTA"
    }
  ],
  "why_for_you": "Ce format marche pour toi parce qu'il transforme une frustration que ton audience vit tous les jours (ne pas comprendre pourquoi ses vidéos floppent) en une démonstration concrète de ta méthode, sans que ça ressemble à un cours. Et le CTA 'commentez ce mot' fait exactement ce que tu enseignes : il booste ton propre taux d'engagement et te permet de prouver en live que tes techniques fonctionnent.",
  "hook_adapted": "Récemment, je me suis demandé à quel point il est facile de poster une vidéo sans jamais savoir pourquoi les gens décrochent.",
  "hook_template": "Récemment, je me suis demandé à quel point il est facile de [Mauvaise pratique courante dans la niche].",
  "script_adapted": "Récemment, je me suis demandé à quel point il est facile de passer 2h sur une vidéo sans jamais comprendre pourquoi les gens la quittent au bout de 3 secondes.\nQuelqu'un tombe sur ton reel, il accroche sur le hook, il est prêt à regarder,\n2 secondes plus tard... il scrolle. Et toi tu vois ton taux de rétention à 30% sans savoir ce que t'as fait de travers.\nC'est exactement pour ça que j'ai commencé à analyser mes vidéos avec une méthode que j'appelle la carte de décrochage, que j'ai construite après avoir testé plus de 40 reels sur mon propre compte.\nCa veut dire que dès que tu regardes tes stats, tu sais exactement à quelle seconde les gens partent et pourquoi.\nJuste un tableau simple avec 3 colonnes et le moment précis où ton audience décroche à chaque fois.\nC'est une façon tellement directe de comprendre ce qui tue tes vidéos\net de savoir quoi changer ce soir sur ton prochain reel, sans changer de niche, sans refaire ton style.\nSi tu veux le modèle complet, commente simplement 'RÉTENTION' et je te l'envoie gratuitement en DM.",
  "script_template": "Récemment, je me suis demandé à quel point il est facile de [Mauvaise pratique courante dans la niche].\nQuelqu'un [Action positive de l'audience], il est [État émotionnel positif] à l'idée de [Bénéfice attendu],\n[Délai court]... il [Comportement de décrochage].\nC'est exactement pour ça que je viens de commencer à utiliser [Nom de l'outil / méthode], que j'ai découvert grâce à [Source de crédibilité].\nCa veut dire que dès que [Déclencheur], [Audience] reçoit automatiquement [Livrable concret].\nJuste [Description simple du contenu] et [Bénéfice immédiat].\nC'est une façon tellement simple de faire en sorte que [Audience] [Résultat émotionnel]\net de commencer à [Résultat relationnel ou business].\nSi vous voulez essayer par vous-même, commentez simplement '[Mot clé CTA]' et je vous envoie [Ressource gratuite]."
};

export const ANTONIN_VIDEO_ANALYSIS = {
  "scoring": {
    "analyse_json": {
      "hook": {
        "note": 7,
        "detail": "Contraste chiffré fort (54k fois) + curiosité test viral. Ancre sociale solide.",
        "hook_type": "Monologue face cam explicatif : format méta-viral"
      },
      "forces": [
        "Mécanique virale participation (commente ta version) + délai 72h crée boucle engagement",
        "Hook chiffré fort (54k fois) avec ancrage social (53M vues) = crédibilité immédiate",
        "Format méta (test sur l'algo) aligné avec audience créateurs, pertinence tribale claire",
        "Écran partagé visuel = démonstration immédiate du contraste (preuve par l'image)"
      ],
      "boucles": {
        "note": 8,
        "detail": "CTA triple (commente/profil/suis) + délai 72h = boucle forte. Invite à comparer 2 versions."
      },
      "densite": {
        "note": 5,
        "detail": "87 mots/29s = 3 mots/s. Acceptable mais respiration lente sur explication 'comment être sûr'."
      },
      "langage": {
        "note": 6,
        "detail": "Oral naturel ('Et ben on peut pas'). Manque punch : zéro métaphore, zéro phrase signature mémorable."
      },
      "rehooks": {
        "note": 7,
        "detail": "Écran partagé 53M vs 992 vues (visuel choc). Annonce test. CTA comparaison. Rappel 72h."
      },
      "connexion": {
        "note": 5,
        "detail": "Ton expert-détaché. Aucun 'tu' incarné avant 20s. Pas de vulnérabilité ni complicité émotionnelle."
      },
      "faiblesses": [
        {
          "label": "Autorité sapée par audience sceptique",
          "conseils": [
            "Anticiper objection 'c'est juste l'algo' dès 10s avec data (12 tests, pattern clair)",
            "Établir credentials : 'Après 247 tests sur 6 mois, voici ce que j'ai découvert'",
            "Montrer screenshot analytics (preuve concrète) pas juste vidéos côte à côte"
          ]
        },
        {
          "label": "Zéro connexion émotionnelle spectateur",
          "conseils": [
            "Passer de 'je fais le test' à 'on va le découvrir ensemble' (complicité)",
            "Ajouter 'toi aussi tu t'es fait avoir par ce mythe ?' (vulnérabilité partagée)",
            "Insérer micro-frustration : 'J'en avais marre de poster dans le vide' (identification)"
          ]
        },
        {
          "label": "Capital social faible = viralité bridée",
          "conseils": [
            "Reformuler CTA : 'Partage à un créateur qui croit encore que l'algo est random'",
            "Créer insider language : 'Les testeurs vs les copieur' (tribu claire)",
            "Ajouter provocation douce : 'Si tu testes pas, tu devines. Et devine quoi : tu perds.'"
          ]
        },
        {
          "label": "Densité narrative inégale (trou 15-20s)",
          "conseils": [
            "Couper 'Et ben on peut pas' (évident) → direct 'Donc je fais le test avec 2 versions'",
            "Ajouter micro-reveal à 18s : 'Et le résultat va te choquer' (relance tension)",
            "Overlay chiffres intermédiaires (ex: '+340% vues version A à 12h') pendant explication"
          ]
        }
      ],
      "suggestion": "Bonne vidéo : 4,1M de vues, c'est rare. Pour la prochaine, crée plus d'émotion en parlant 'à' ton spectateur, pas 'devant' lui. Remplace 'je fais le test' par 'on découvre ensemble' = +20% de rétention.",
      "hook_anatomy": {
        "actuel": {
          "longueur_mots": 21,
          "biais_cognitifs": [
            "Preuve sociale (53M vues)",
            "Contraste extrême (54 000x)",
            "Paradoxe apparent"
          ],
          "emotion_primaire": "Curiosite",
          "formule_syntaxique": "Ces deux X ont Y identique et pourtant Z différence extrême",
          "mecanisme_rhetorique": "Paradoxe chiffré"
        },
        "evaluation": "Le hook audio fonctionne : chiffre énorme (54k fois), paradoxe script identique/résultats opposés, ancrage social (53M). Overlay 'EXACTEMENT LE MÊME SCRIPT' renforce. MAIS introduction '[EXTRAIT] You don't wanna study?' crée confusion (c'est quoi ce teaser ?). Ref 2 (Caroline 1.1K→41K) utilise même mécanique contraste-résultat mais avec personne incarnée + émotionnel. Ici : trop analytique, pas de 'toi aussi tu peux'.",
        "score_sur_10": 7,
        "ameliorations": [
          {
            "quoi": "Formule",
            "action": "Ajouter 'Et toi, tu aurais deviné pourquoi ?' en fin de phrase 1 pour activer prédiction",
            "probleme": "Contraste efficace mais pas d'implication directe spectateur",
            "impact_attendu": "+15% rétention 0-3s"
          },
          {
            "quoi": "Intro teaser",
            "action": "Supprimer ou remplacer par visuel pomme direct en frame 1 (pas d'audio parasite)",
            "probleme": "'[EXTRAIT] You don't wanna study' hors sujet, crée friction",
            "impact_attendu": "Clarté immédiate, -20% drop early"
          },
          {
            "quoi": "Emotion primaire",
            "action": "Ajouter '...et ça pourrait tuer ton compte si tu fais l'erreur' après '54k fois plus'",
            "probleme": "Curiosité pure sans tension émotionnelle (pas de peur ni désir)",
            "impact_attendu": "Urgence perçue +30%"
          }
        ]
      },
      "note_globale": 6,
      "plan_action_top3": [
        {
          "bloc": "Seaux",
          "action": "Ajouter auto-identification tribale dès 5s : 'Si toi aussi tu galères à percer l'algo...'",
          "pourquoi": "Connexion émotionnelle quasi nulle (score 5/10), audience ne se projette pas. Impact : +40% sentiment appartenance.",
          "priorite": 1
        },
        {
          "bloc": "Leviers",
          "action": "Reformuler CTA en 'Tag un créateur qui croit aux hacks magiques' (activation tribale + humour)",
          "pourquoi": "Capital social moyen (6/10) bride viralité. Partage actuel = utilité seule. Impact : +60% partages, reach explosif.",
          "priorite": 2
        },
        {
          "bloc": "Commentaires",
          "action": "Anticiper objection 'c'est l'algo' à 10s avec '12 tests prouvent un pattern clair' + screenshot data",
          "pourquoi": "Autorité sapée (score 4/10), audience rejette prémisse. Neutraliser = crédibilité +50%, rétention mid-vidéo sauvée.",
          "priorite": 3
        }
      ],
      "seaux_semantiques": {
        "actuel": {
          "tribu_visee": "Créateurs de contenu TikTok/IG obsédés par algo et croissance virale",
          "desir_active": "Percer le secret de l'algo, prédire la viralité, maîtriser les vues",
          "ennemi_designe": "Le hasard, l'imprévisibilité de l'algorithme, les fausses croyances",
          "douleur_exploitee": "Incertitude sur ce qui fait performer une vidéo (mystère algo)",
          "emotion_dominante": "Curiosite",
          "niveau_conscience": "solution-aware"
        },
        "evaluation": "Tribu claire (créateurs), douleur réelle (mystère algo). MAIS désir sous-exploité : pas de bénéfice personnel ('tes vidéos vont exploser si'). Ennemi flou : on attaque l'incertitude mais on ne nomme pas l'erreur fatale (ex: 'ceux qui croient que l'algo est magique'). Ref 3 ('Sans nommer profession...') active identité tribale immédiate via participation. Ici : spectateur = observateur passif, pas acteur du test.",
        "score_sur_10": 5,
        "ameliorations": [
          {
            "quoi": "Tribu visée",
            "action": "Insérer dès 5s : 'Si toi aussi tu te demandes pourquoi tes vidéos marchent pas...'",
            "probleme": "Pas d'auto-identification explicite ('si tu galères à 300 vues...')",
            "impact_attendu": "Connexion identitaire +40%"
          },
          {
            "quoi": "Douleur exploitée",
            "action": "Remplacer 'comment être sûr' par 'T'en as marre de poster dans le vide sans savoir pourquoi ?'",
            "probleme": "Douleur intellectuelle (curiosité) pas viscérale (frustration, peur)",
            "impact_attendu": "Engagement émotionnel +25%"
          },
          {
            "quoi": "Ennemi désigné",
            "action": "Nommer 'ceux qui croient aux hacks magiques sans tester' comme ennemi culturel",
            "probleme": "Pas d'antagoniste clair (algo abstrait)",
            "impact_attendu": "Polarisation +20%, partages identitaires"
          },
          {
            "quoi": "Désir activé",
            "action": "Ajouter 'Je te montre exactement ce qui change tout' après annonce test",
            "probleme": "Pas de promesse de transformation ('toi aussi tu peux reproduire')",
            "impact_attendu": "Attente résultats +35%"
          }
        ]
      },
      "commentaires_analyse": {
        "actuel": {
          "verbatims_cles": [
            "L'algorithme m'a proposé celle ci ! C'est tout (34k❤️)",
            "L'ETIQUETTE ! OH BORDEL (9k❤️)",
            "ÉTIQUETTE M'A STRESSÉ",
            "Pomme ou pas je m'en fou par contre t'as coupé sans enlever l'étiquette",
            "Visiblement c'est la pomme"
          ],
          "questions_audience": [],
          "sentiment_dominant": "Neutre curieux",
          "objections_recurrentes": [
            "C'est juste l'algo qui décide (hasard), pas la pomme",
            "L'étiquette sur la pomme est perturbante/stressante (détail visuel parasite)"
          ]
        },
        "evaluation": "Participation forte (13 commentaires = engagement actif) MAIS détournement massif : l'étiquette pomme capte plus d'attention que le message (3 commentaires top). L'audience est sceptique ('c'est l'algo... c'est tout') = ton autorité n'est pas établie, ils rejettent ta prémisse. Pas de questions sur la méthode ni de demande de suite = faible attente émotionnelle. Comparé aux refs : zéro effet tribal, zéro débat passionné.",
        "score_sur_10": 4,
        "ameliorations": [
          {
            "quoi": "Gestion objections",
            "action": "Anticiper dès 10s : 'Oui l'algo joue, MAIS regarde ces 12 tests identiques : pattern clair'",
            "probleme": "Audience rejette prémisse ('c'est juste l'algo'), tue la tension narrative",
            "impact_attendu": "Crédibilité +50%, objections neutralisées"
          },
          {
            "quoi": "Détail visuel parasite",
            "action": "Enlever étiquette OU en faire un running gag conscient ('Oui l'étiquette, c'est le vrai test')",
            "probleme": "Étiquette pomme détourne attention (3 commentaires top), affaiblit message",
            "impact_attendu": "Focus message +30%"
          },
          {
            "quoi": "Questions audience",
            "action": "Insérer 'Et devine ce que les données révèlent sur TON compte' (personnalisation)",
            "probleme": "Zéro question = faible curiosité projetée dans le futur",
            "impact_attendu": "Questions en commentaires +70%"
          },
          {
            "quoi": "Sentiment dominant",
            "action": "Ajouter reveal choc à 15s : 'Résultat : 89% des créateurs font l'inverse de ce qui marche'",
            "probleme": "Neutre curieux = émotionnellement plat, pas de passion ni urgence",
            "impact_attendu": "Pic émotionnel, commentaires chargés +40%"
          }
        ]
      },
      "circuit_dopaminergique": {
        "note": 6,
        "detail": "Promesse de résultats différés (72h) crée attente. Démonstration pomme visuelle. Manque peak émotionnel."
      },
      "leviers_psychologiques": {
        "actuel": {
          "capital_social": "moyen",
          "mecanisme_viral": "Participation à expérience collective (commente ta version) + curiosité résultats futurs (72h)",
          "potentiel_debat": 4,
          "raison_partager": "utilite",
          "raison_enregistrer": "reference"
        },
        "evaluation": "Mécanique virale intelligente : CTA 'commente celle que tu as vue' + délai 72h crée engagement différé. MAIS capital social faible : partager ce contenu ne fait pas de toi un insider ni un expert (juste un participant). Ref 1 ('Pick your 3') donne statut créatif. Ici : tu deviens cobaye, pas leader. Commentaires montrent participation ('celle-ci', 'la pomme') mais zéro débat idéologique ni tribal.",
        "score_sur_10": 6,
        "ameliorations": [
          {
            "quoi": "Raison partager",
            "action": "Ajouter 'Tag un créateur qui croit encore aux hacks bidon' pour activer tribu + humour",
            "probleme": "Utilité seule = viralité faible. Pas de boost identitaire ni émotionnel",
            "impact_attendu": "Partages +60%, reach viral"
          },
          {
            "quoi": "Capital social",
            "action": "Reformuler en 'Les vrais créateurs testent, les autres copient' (insider vs outsider)",
            "probleme": "Partager ne signale ni expertise ni appartenance tribale forte",
            "impact_attendu": "Statut perçu +50% chez partageurs"
          },
          {
            "quoi": "Potentiel débat",
            "action": "Introduire friction : 'La plupart des coach vous mentent sur l'algo, voici la vérité'",
            "probleme": "Sujet consensuel (tout le monde est d'accord que algo est mystérieux)",
            "impact_attendu": "Commentaires polarisés +80%"
          },
          {
            "quoi": "Raison enregistrer",
            "action": "Ajouter 'Je te donne les 3 patterns qui marchent à tous les coups' en clôture",
            "probleme": "Référence faible (juste un test en cours, pas un framework réutilisable)",
            "impact_attendu": "Saves +45%, autorité perçue"
          }
        ]
      }
    },
    "gemini": {
      "script_complet": "[EXTRAIT] You don't wanna study? : Ces deux vidéos ont exactement le même script et pourtant il y en a une qui a eu cinquante-quatre-mille fois plus de vues que l'autre. Et tout le monde pense que c'est parce que dans la première, la fille coupe une pomme pendant qu'elle est en train de parler. Et que c'est ça qui garde l'attention du spectateur. Mais comment est-ce qu'on peut en être sûr ? Et ben on peut pas. Donc je fais le test. J'ai publié deux versions de la même vidéo. Une dans laquelle je coupe une pomme et l'autre sans. Donc commente sur celle que tu as vu en premier et va voir sur mon profil celle qui performe le mieux. Et surtout suis-moi si tu veux pas louper les résultats dans 72h.",
      "hook_audio_verbatim": "Ces deux vidéos ont exactement le même script et pourtant il y en a une qui a eu cinquante-quatre-mille fois plus de vues que l'autre.",
      "hook_visuel_verbatim": "ONT EXACTEMENT LE MÊME SCRIPT",
      "description_visuelle": "## PERSONNES\nUne personne principale apparaît à l'écran, un homme barbu, filmé de face. Il ne change pas de rôle. Deux autres personnes, des femmes, apparaissent dans des incrustations vidéo. La première femme est filmée de face, coupant une pomme. La seconde femme est filmée de face, posant avec les mains derrière la tête. Il n'y a pas d'interaction directe entre l'homme et les femmes incrustées.\n\n## CADRAGE & MISE EN SCENE\nLe cadrage principal est un plan moyen de l'homme, avec un gros plan sur ses mains coupant une pomme sur une planche en bois. Le cadrage change avec l'apparition d'un écran partagé, affichant deux vidéos plus petites sur les côtés de l'homme. Le décor est un mur de couleur claire en arrière-plan et une table en bois. Le tournage est statique.\n\n## TEXTE & ELEMENTS VISUELS\nDu texte est affiché à l'écran, servant de contenu principal et d'explication : \"53,4M vues\", \"992 vues\", \"ONT EXACTEMENT LE MÊME SCRIPT\", \"CINQUANTE-QUATRE MILLE FOIS PLUS DE VUES QUE L'AUTRE\", \"C'EST PARCE QUE LA FILLE COUPE 1 POMME PENDANT QU'ELLE EST EN TRAIN DE PARLER\", \"L'ATTENTION DU SPECTATEUR\", \"MAIS COMMENT EST-CE QU'ON PEUT ÊTRE SÛR\", \"ET BEN ON PEUT PAS\", \"DONC JE FAIS LE TEST\", \"J'AI PUBLIÉ 2 VERSIONS DE LA MÊME VIDÉO\", \"UNE DANS LAQUELLE JE COUPE 1 POMME ET L'AUTRE SANS\". Un encadré avec \"Commente « celle ci » si tu la vois en premier\" apparaît. Le texte se termine par \"SUIS-MOI SI TU NE VEUX PAS LOUPER LES RÉSULTATS DANS 72H\". Des flèches rouges et un cercle rouge sont incrustés sur la première vidéo de la femme coupant une pomme.\n\n## VOIX & SON\nL'homme filmé parle en voix off. Le ton est éducatif et explicatif, présentant une expérience. Une musique d'ambiance entraînante est présente en fond sonore.\n\n## STRUCTURE & RYTHME\nLa vidéo commence par l'homme coupant une pomme, avec un écran partagé montrant deux vidéos et leurs nombres de vues très différents, malgré un script identique. Elle explique une hypothèse sur la raison de cette différence, puis annonce un test pour la vérifier. La vidéo se termine par un appel à l'action demandant aux spectateurs de commenter quelle version ils ont vue en premier et de suivre pour les résultats dans 72 heures. Le montage est dynamique avec des apparitions de texte fréquentes.\n\n## INTERACTION\nLe créateur s'adresse directement au spectateur en lui demandant de commenter quelle version de la vidéo il a vue en premier et de le suivre pour les résultats. Il n'y a pas de personnes interviewées ni d'éléments de jeu/défi/vote au-delà de l'appel à l'action."
    },
    "comments": {
      "stats": {
        "total_fetched": 13
      }
    }
  },
  "reel_metadata": {
    "thumbnail_url": reelThumb,
    "caption": "Comment hacker la rétention ⬇️\n\nEst-ce que couper une pomme permet d’occuper le cerveau du spectateu",
    "views": 4571501,
    "likes": 178012,
    "duration_seconds": 29
  },
  "reel_shortcode": "DVylFdyCNcy"
};

// Score réel d'antonin_girardeau (session Studio dev, 2026-06-18).
// Rendu par le vrai composant <AccountScore> sur la LP = le "graph" du wow gratuit.
export const ANTONIN_SCORE = {
  "global": 45,
  "dimensions": [
    { "key": "niche", "label": "Niche", "value": 48 },
    { "key": "offre", "label": "Offre", "value": 38 },
    { "key": "engagement", "label": "Engagement", "value": 35 },
    { "key": "regularite", "label": "Régularité", "value": 43 },
    { "key": "monetisation", "label": "Monétisation", "value": 30 },
    { "key": "audience", "label": "Audience", "value": 73 }
  ]
};

// Correctifs réels tirés de l'analyse de compte d'antonin_girardeau
// (merlin_avis.faiblesses_recurrentes + recommandations). On garde les
// lignes universelles (pas les conseils méta sur Merlin) pour montrer
// concrètement ce que l'analyse délivre, axe par axe. CM2.
export const ANTONIN_ACCOUNT_FIXES = [
  {
    "axe": "Monétisation",
    "note": 30,
    "constat": "On ne sait pas ce que tu vends.",
    "correctif": "Dis en 1 ligne ce que tu proposes. Les gens prêts à acheter abandonnent si c'est flou."
  },
  {
    "axe": "Engagement",
    "note": 35,
    "constat": "Tu n'as aucune preuve que ça marche.",
    "correctif": "Montre un vrai résultat. Un avant / après concret vaut plus que 30 vidéos de conseils."
  },
  {
    "axe": "Régularité",
    "note": 43,
    "constat": "Tu ne postes pas assez souvent.",
    "correctif": "Passe à 3 vidéos par semaine. Tes vues sont bonnes, l'algo est prêt à te pousser plus."
  }
];
